import { Col, Form, FormInstance, Row } from 'antd';
import VehicleAlert, { AlertStatus } from '../VehicleAlert';
import VehicleForm from '../VehicleForm';
import VehicleLicensePlate from '../VehicleLicensePlate';
import { CustomerVehicle } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import { VehicleFormValues } from '../VehicleModal.types';
import { useEffect, useState } from 'react';
import { AuthorityDefault } from '@/types/Authority/Authority.Default';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import VehicleEngineDataForm from '../VehicleEngineDataForm';
import VehicleImage from '../VehicleImage';

import './style.less';
import { isAppPortocar } from '@/index';
import VehiclAdditionalInformationForm from '../VehiclAdditionalInformationForm';
import Authorities from '@/types/Authority';

interface Props {
  form: FormInstance<VehicleFormValues>;
  customerId?: number;
  vehicle?: CustomerVehicle;
  removeAlert?: boolean;
  onChangeAlert?: (status?: AlertStatus) => void;
  onChangeVehicle?: () => void;
  disabledFields?: boolean;
  consultLicensePlate?: boolean;
  licensePlate?: string;
  handleFormChange?: (changeValues: []) => void;
}

const VehicleFormWrapper: React.FC<Props> = ({
  form,
  customerId,
  vehicle,
  removeAlert = false,
  onChangeAlert,
  onChangeVehicle,
  disabledFields = false,
  consultLicensePlate = false,
  licensePlate,
  handleFormChange,
}) => {
  const [disabled, setDisabled] = useState(false);

  const formDisabled = disabled || disabledFields;

  useEffect(() => {
    return () => setDisabled(false);
  }, []);

  function handleChangeAlert(status?: AlertStatus) {
    if (status !== undefined) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
    !!onChangeAlert && onChangeAlert(status);
  }

  return (
    <Form
      form={form}
      onValuesChange={(changeValues) =>
        handleFormChange && handleFormChange(changeValues)
      }
      disabled={
        !hasPermissions([
          Authorities.REGISTER_CUSTOMER_VEHICLE_EDIT,
          Authorities.REGISTER_CUSTOMER_VEHICLE_ADD,
        ])
      }
    >
      {!removeAlert && (
        <VehicleAlert
          customerId={customerId}
          licensePlate={vehicle?.licensePlate}
          onChange={handleChangeAlert}
          onChangeVehicle={onChangeVehicle}
        />
      )}

      {((isAppPortocar && !vehicle) || !isAppPortocar) && (
        <VehicleLicensePlate
          consultLicensePlate={consultLicensePlate}
          licensePlate={licensePlate}
          vehicle={vehicle}
        />
      )}

      <Row gutter={[12, 12]} align="middle" className="vehicle-form-container">
        <Col span={24} md={16}>
          <VehicleForm
            disabledFields={
              formDisabled &&
              hasPermissions([AuthorityDefault.DEFAULT_INTEGRATION_FRAGA])
            }
            isEdit={!!vehicle}
            vehicle={vehicle}
          />
        </Col>

        <Col span={24} md={8}>
          <VehicleImage
            disabledFields={
              formDisabled &&
              hasPermissions([AuthorityDefault.DEFAULT_INTEGRATION_FRAGA])
            }
          />
        </Col>

        <Col span={24}>
          <VehicleEngineDataForm
            disabledFields={
              formDisabled &&
              hasPermissions([AuthorityDefault.DEFAULT_INTEGRATION_FRAGA])
            }
          />
        </Col>

        <Col span={24}>
          <VehiclAdditionalInformationForm
            disabledFields={
              formDisabled &&
              hasPermissions([AuthorityDefault.DEFAULT_INTEGRATION_FRAGA])
            }
          />
        </Col>
      </Row>
    </Form>
  );
};

export default VehicleFormWrapper;
